import Image from 'next/image'
import Link from 'next/link'
import { FC } from 'react'

import styles from './SpaceJoin.module.scss'

export type WhyCardProps = {
	imageSrc: string
	alt?: string
	title: string
	subtitle: string
	link: string
}

export const SpaceJoin: FC<WhyCardProps> = ({ imageSrc, title, alt = title, subtitle, link }) => {
	return (
		<article className={styles.card}>
			<div className={styles.text}>
				<h3 className={styles.title}>{title}</h3>
				<p className={styles.subtitle}>{subtitle}</p>
				<Link prefetch={false} href={link} className={styles.link} target="_blank">
					Подробнее
				</Link>
			</div>
			<Image src={imageSrc} alt={alt} width={598} height={414} className={styles.image} />
		</article>
	)
}
